import { FormGroup, Validators } from "@angular/forms";

import { isEmpty } from "lodash";

import { CommunicationMethodTypeCode, PROTOCOL_FORM_PARAMS } from "src/app/models/protocol/protocol.model";

export function setProtocolFormValues(formGroup: FormGroup, entity: any) {
  if (!entity) {
    return;
  }

  const protocolFormGroup = formGroup.get('protocol') as FormGroup;

  if (!protocolFormGroup || isEmpty(protocolFormGroup.controls)) {
    return;
  }

  const { communicationMethodTypeCode, communicationMethodData } = entity;

  if (protocolFormGroup.controls.forecourtEventClientIp && protocolFormGroup.controls.forecourtEventClientPort) {
    protocolFormGroup.controls.forecourtEventClientIp.setValue(entity.additionalData.forecourtEventClientIp);
    protocolFormGroup.controls.forecourtEventClientPort.setValue(entity.additionalData.forecourtEventClientPort);
  }

  switch (communicationMethodTypeCode) {
    case CommunicationMethodTypeCode.IP_PROTOCOL:
      protocolFormGroup.controls.communicationMethodTypeCode.setValue(false);
      protocolFormGroup.controls.ipAddress.setValue(communicationMethodData.ipAddress);
      protocolFormGroup.controls.port.setValue(communicationMethodData.port);
      disableFields(protocolFormGroup, [PROTOCOL_FORM_PARAMS.address, PROTOCOL_FORM_PARAMS.baudRate]);
      enableFields(protocolFormGroup, [PROTOCOL_FORM_PARAMS.ipAddress, PROTOCOL_FORM_PARAMS.port]);
      break;
    case CommunicationMethodTypeCode.SERIAL_CONNECTION:
      protocolFormGroup.controls.communicationMethodTypeCode.setValue(true);
      protocolFormGroup.controls.address.setValue(communicationMethodData.address);
      protocolFormGroup.controls.baudRate.setValue(communicationMethodData.baudRate);
      disableFields(protocolFormGroup, [PROTOCOL_FORM_PARAMS.ipAddress, PROTOCOL_FORM_PARAMS.port]);
      enableFields(protocolFormGroup, [PROTOCOL_FORM_PARAMS.address, PROTOCOL_FORM_PARAMS.baudRate]);
      break;
    default:
      break;
  }
}

export function disableFields(form: FormGroup, formFields: string[]) {
  formFields.forEach((field) => {
    form.get(field).clearValidators();
    form.get(field).updateValueAndValidity();
    form.get(field).setValue(null);
    form.get(field).disable();
  });
}

export function enableFields(form: FormGroup, formFields: string[]) {
  formFields.forEach((field) => {
    switch (field) {
      case PROTOCOL_FORM_PARAMS.ipAddress:
        form.get(field).setValidators([Validators.required]);
        break;
      case PROTOCOL_FORM_PARAMS.port:
        form.get(field).setValidators([Validators.required, Validators.min(1), Validators.max(65535), Validators.pattern('^[0-9]+$')]);
        break;
      case PROTOCOL_FORM_PARAMS.address:
        form.get(field).setValidators([Validators.required, Validators.min(0), Validators.max(255)]);
        break;
      case PROTOCOL_FORM_PARAMS.baudRate:
        form.get(field).setValidators([Validators.required, Validators.min(0), Validators.max(100000)]);
        break;
      default: 
        break;
    }
    form.get(field).updateValueAndValidity();
    form.get(field).enable();
  });
}

export function setCommunicationMethodData(protocolFormGroup: FormGroup) {
  if (protocolFormGroup.get(PROTOCOL_FORM_PARAMS.communicationMethodTypeCode).value) {
    return {
      address: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.address).value ?? null,
      baudRate: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.baudRate).value ?? null,
    };
  } else {
    return {
      ipAddress: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.ipAddress).value ?? null,
      port: protocolFormGroup.get(PROTOCOL_FORM_PARAMS.port).value ?? null,
    };
  }
}
